export default {
  title: 'IRA accounts',
  newIraButton: 'New IRA',
  exportCsvButton: 'Export CSV',
};
